/**
 * Alert Fiedset Module is a reusable Module
 */

// Angular
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
// module
import { DropdownModule } from 'primeng/dropdown';
// Own Components
import { DropdownFieldComponent } from "libraries/module/formbuilder/fields/dropdown-field/dropdown-field.component";
import { FormBuilderService } from "libraries/service/formBuilder/formBuilder.service";
import { FocusMeModule } from "libraries/directive/focusMe/focusMe.module";
import { FormFieldModule } from '../form-field/form-field.module';

/**
 * @deprecated
 */
@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        DropdownModule,
        FocusMeModule,
        FormFieldModule,
    ],
    declarations: [
        DropdownFieldComponent
    ],
    exports: [
        DropdownFieldComponent
    ],
    providers:[
        FormBuilderService
    ]
})
export class DropdownFieldModule { }
